export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_Faq-28087400dbf44ba632d759cd426ed383.jpg";